module.exports = __webpack_public_path__ + "img/Group 57@2x.05fb7865.png";